module.exports = __webpack_public_path__ + "media/images/person_avatar_128x128-6bebea66870dec5a58945b2f0826f01e.png";